<template>
	<v-dialog v-model="showDialog" max-width="600">
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 使いさし削除 </v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<p>以下の使いさしデータを削除しますが、本当によろしいですか。</p>
				<div class="mt-4">
					<!-- TODO -->
					<table width="100%" v-if="type == 'rubber'" class="show-dialog-table">
						<tbody>
							<ShowDetailRecord :columnName="'長さ'" :value="'XX'" />
							<ShowDetailRecord :columnName="'本数'" :value="'XX'" />
						</tbody>
					</table>
					<table width="100%" v-if="type == 'item_kg'" class="show-dialog-table">
						<tbody>
							<ShowDetailRecord :columnName="'使いさし重量'" :value="'XX'" />
						</tbody>
					</table>
				</div>
			</div>
			<v-card-actions>
				<v-row no-gutters>
					<v-col sm="2" cols="0" />
					<v-col sm="8" cols="12" class="text-center">
						<v-btn color="red" dark @click="deletePartiallyUsedItem">
							<v-icon class="mr-1">mdi-delete</v-icon>
							削除する
						</v-btn>
					</v-col>
					<v-col sm="2" cols="0" class="text-right">
						<v-btn v-if="!$vuetify.breakpoint.xs" color="grey darken-1" text @click="closeDialog">
							キャンセル
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		type: {
			type: String,
			required: true,
		},
		partially_user_item: {
			type: null,
			required: false,
		},
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {}
	},
	methods: {
		deletePartiallyUsedItem() {
			this.$emit("delete-item", this.partially_user_item)
			this.closeDialog()
		},
		closeDialog() {
			this.showDialog = false
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(value) {
				this.$emit("update:dialog", value)
			},
		},
	},
}
</script>